import { render, staticRenderFns } from "./ViewAuctionComponent.vue?vue&type=template&id=618481df"
import script from "./ViewAuctionComponent.vue?vue&type=script&lang=js"
export * from "./ViewAuctionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports